/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
`
export default class PickNoticeIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" css={Color}>
        <g id="그룹_8839" data-name="그룹 8839" transform="translate(-4884 -22094)">
          <rect id="사각형_7370" data-name="사각형 7370" width="18" height="18" transform="translate(4884 22094)" fill="red" opacity="0"/>
          <path id="합치기_268" className="fill" data-name="합치기 268" d="M4.6,9.292V3.053L14.92,0V12.4L7.979,10.317l.8,5.108-2.92,0ZM1.47,9.1A1.469,1.469,0,0,1,0,7.636v-2.9a1.47,1.47,0,0,1,1.47-1.47H2.939V9.1Z" transform="translate(4885.286 22095.285)" fill="#ddd" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
          <rect id="사각형_7369" data-name="사각형 7369" width="14.921" height="15.428" transform="translate(4885.286 22095.285)" fill="none"/>
        </g>
      </svg>
    )
  }
}
